// Which employee and which bank record the Bank Details screen shows.
// Only the chosen employee's own record is ever shown: when they have none the form is empty,
// never another person's account (triage G09, FE-06-01).
// A person can have several versions of their account (a change is a new version, FE-06-S07); the form
// shows the current one: not replaced, and the newest.
export function pickEmployeeAndAccount(data, selectedEmployeeId) {
  const hasChoice = selectedEmployeeId !== undefined && selectedEmployeeId !== null && selectedEmployeeId !== "";
  const employee = hasChoice ? (data.employees || []).find((item) => String(item.id) === String(selectedEmployeeId)) || {} : {};
  const account = hasChoice ? currentAccount(accountsOf(data, selectedEmployeeId)) || {} : {};
  return { employee, account };
}

export function accountsOf(data, selectedEmployeeId) {
  return (data.bankAccounts || []).filter((item) => String(item.employee) === String(selectedEmployeeId));
}

export function currentAccount(accounts) {
  return accounts.filter((item) => !item.superseded_at).sort((a, b) => Number(b.id) - Number(a.id))[0];
}

// The status a row shows: a replaced version says so; the current one shows whether finance verified it.
export function accountStatus(item) {
  return item.superseded_at ? "Replaced" : item.verification_status;
}
